import { BASE_URL } from 'config/urls';

import { callUrl, get } from 'utils/sdk';

export const tasksList = (assignmentId) =>
  callUrl(
    get,
    `${BASE_URL}/v1/trackers/assignments/${assignmentId}/tasks-list/`
  );
